import { Route, Switch } from "wouter";
import { Nav } from "./components/Nav.js";
import { Dashboard } from "./components/Dashboard.js";
import { CabinetDetail } from "./routes/CabinetDetail.js";
import { FaultyBatteries } from "./routes/FaultyBatteries.js";
import { ActiveRentals } from "./routes/ActiveRentals.js";
import { UptimeSLA } from "./routes/UptimeSLA.js";
import { BatteryLifecycle } from "./routes/BatteryLifecycle.js";
import { Shops } from "./routes/Shops.js";
import { Docs } from "./routes/Docs.js";

function NotFound() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-16 text-center">
      <h1 className="text-2xl font-semibold text-zinc-100">404</h1>
      <p className="mt-2 text-sm text-zinc-500">No page at this URL.</p>
    </div>
  );
}

export function App() {
  return (
    <main className="relative min-h-full bg-ink-950">
      {/* Top accent line — purple → orange gradient */}
      <div className="pointer-events-none fixed inset-x-0 top-0 z-0 h-px bg-brand-gradient opacity-60" />
      {/* Soft glow on the top-left and bottom-right */}
      <div className="pointer-events-none fixed -left-32 -top-32 z-0 h-96 w-96 rounded-full bg-brand-purple/10 blur-3xl" />
      <div className="pointer-events-none fixed -bottom-32 -right-32 z-0 h-96 w-96 rounded-full bg-brand-orange/10 blur-3xl" />
      <Nav />
      <div className="relative z-10">
        <Switch>
          <Route path="/" component={Dashboard} />
          <Route path="/cabinets/:id" component={CabinetDetail} />
          <Route path="/batteries/faulty" component={FaultyBatteries} />
          <Route path="/batteries/:id" component={BatteryLifecycle} />
          <Route path="/rentals/active" component={ActiveRentals} />
          <Route path="/uptime" component={UptimeSLA} />
          <Route path="/shops" component={Shops} />
          <Route path="/docs" component={Docs} />
          <Route component={NotFound} />
        </Switch>
      </div>
    </main>
  );
}
